import React, { FunctionComponent } from 'react';

type Props = {
  section: 'company' | 'userAuth' | 'planPurchase';
  name: string;
  divClassName: string;
  labelName: string;
  required: boolean;
  inputId: string;
  inputClassName: string;
  value: string;
  onChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean | number) => void;
  hintMessage?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  section,
  name,
  divClassName,
  labelName,
  required,
  inputId,
  inputClassName,
  value,
  onChange,
  hintMessage,
}) => {
  return (
    <div className={divClassName}>
      <div className="col-xs-3 col-form-label management-form-section-label form-group__title">
        <label>{labelName}</label>
        {required &&
          <span className="management-form-section-label-essential col-xs-2 priority">&nbsp;必須</span>
        }
      </div>
      <div className="col-xs-7 input hidden-xs">
        <input
          type="text"
          id={inputId}
          className={inputClassName}
          value={value}
          onChange={(e) => onChange(section, name, e.target.value)}
        />
        {hintMessage &&
          <p className="management-form-section-label-note">
            {hintMessage}
          </p>
        }
      </div>
    </div>
  );
};
